import { Component } from 'react'
import { IconStyles, IconTypes } from 'components/Customize/Styling/IconPicker/Constants'
import { getUserAvatarUrl } from 'shared-web/src/components/Avatar'
import Widget from 'components/Customize/Preview/Widget'

import SliderMessagePreview from './SliderMessagePreview'

import {
  SliderPreviewsWrapper,
  SliderPreview,
  Wrapper as WrapperClass,
  Content as MessageClass,
} from './style'

export default class SliderMessageBuilder extends Component {
  renderPASlider(isExpanded = false) {
    const {
      widgetContent: { message, headline, ctaCopy, selectedUser },
      defaultEmbed: {
        theme: { backgroundColor, foregroundColor, iconUrl, iconStyle = IconStyles.SOLID1 },
      },
      hideCta,
    } = this.props
    const primaryColor = (typeof backgroundColor === "string" && !backgroundColor.startsWith('#') && backgroundColor.length === 6 ? `#${backgroundColor}` : backgroundColor)
    const secondaryColor = (typeof foregroundColor === "string" && !foregroundColor.startsWith('#') && foregroundColor.length === 6 ? `#${foregroundColor}` : foregroundColor)
    const content = <div className={MessageClass} dangerouslySetInnerHTML={{ __html: message }} />
    return (
      <div className={SliderPreview}>
        <SliderMessagePreview
          headline={headline}
          content={content}
          isExpanded={isExpanded}
          ctaCopy={ctaCopy}
          hideCta={hideCta}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
        />
        <Widget
          iconType={IconTypes.announcementSrc}
          iconStyle={iconStyle}
          avatarUrl={getUserAvatarUrl(selectedUser)}
          iconUrl={iconUrl}
          backgroundColor={backgroundColor}
          foregroundColor={foregroundColor}
        />
      </div>
    )
  }
  render() {
    return (
      <div className={WrapperClass} style={{ overflowY: 'auto' }} key="slider-previews">
        <div className={SliderPreviewsWrapper}>
          {this.renderPASlider(false)}
          {this.renderPASlider(true)}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/shared/MessagePreviews/SliderMessage/SliderMessageBuilder/index.js